import { FavoriteBorder } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { USE_ACTION_DRAWER } from "../../../hooks/useActionDrawer";
import { useWishlistValue } from "../../../hooks/useWishlist";

const ViewWishListBtn: React.FC = () => {
  const wishlist = useWishlistValue();
  const setDrawer = useSetRecoilState(USE_ACTION_DRAWER);

  return (
    <Tooltip title="Voir Mes Favoris">
      <IconButton color="inherit" onClick={() => setDrawer("WISHLIST")}>
        <Badge
          variant="standard"
          badgeContent={wishlist.carts.length}
          color="secondary"
        >
          <FavoriteBorder />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ViewWishListBtn;
